import Vue from "vue";
import Router from "vue-router";
import systemRoutes from "../views/system/router";
// import mallTourRoutes from '../views/mall/tour/router'
import orderRoutes from "../views/order/router";
// import amendRoutes from '../views/amend/router'
import tradeRoutes from "../views/trade/router";
// import tourRoutes from '../views/manage/tour/router'
// import tripRoutes from '../views/manage/trip/router'
import flightCNRoutes from "../views/manage/flightCN/router";
import flightRoutes from "../views/manage/flight/router";
import mallflightCNRoutes from "../views/mall/flightCN/router";
import mallflightGJRoutes from "../views/mall/flightGJ/router";
import mallhotelCNRoutes from "../views/mall/hotelCN/router";
import mallhotelGJRoutes from "../views/mall/hotelGJ/router";
import mallTrainRoutes from "../views/mall/train/router";
// import recepayRoutes from '../views/recepay/router'
// import TrainOrderRoutes from '../views/manage/TrainOrder/router'
// import TrainTicketReferRoutes from '../views/manage/TrainTicketRefer/router'
import baseRoutes from "../views/base/router";
const dashboard = (resolve) => require(["../views/dashboard.vue"], resolve);
const fullscreen = (resolve) => require(["../views/fullscreen.vue"], resolve);
const index = (resolve) => require(["../views/index.vue"], resolve);
const p404 = (resolve) => require(["../views/404.vue"], resolve);
import mallRoutes from "../views/mall/router";
import btripplatformRoutes from "../views/btrip-platform/router";
import meetingRoutes from "../views/meeting/router";
import billRoutes from "../views/bill/router";
import demandRoutes from "../views/mall/demand/router";

import newdemandRoutes from "../views/mall/newdemand/router";
import manageRouter from "../views/manage/router";
import invoiceRouter from "../views/invoice/router";
import expressRouter from "../views/express/router";
import insuranceRouter from "../views/insurance/router";
import adminRouter from "../views/admin/router";
import statisticsRouter from "../views/statistics/router";
// import HotelCNRouter from '../views/manage/hotelCN/router'
import policyRouter from "../views/manage/policy/router";
import btripRouter from "../views/btrip/router";
import adapterRouter from "../views/adapter/router";
Vue.use(Router);
var routeCache = {};

function fnMergeRoute(route) {
  if (route.name == undefined || route.name == "") {
    routes.push(route);
    return;
  }
  var cache = routeCache[route.name];
  if (!cache) {
    cache = route;
    routeCache[route.name] = route;
    routes.push(route);
    return;
  }
  cache.children = _.union(cache.children, route.children);
}

var routes = [];
 $utils.each(
   [
     {
       path: "/fullscreen",
       name: "fullscreen",
       component: fullscreen,
       meta: {
         requiresAuth: true,
       },
       children: [],
     },
   ],
   fnMergeRoute
 );
$utils.each(systemRoutes, fnMergeRoute);
// $utils.each(mallTourRoutes, fnMergeRoute);
$utils.each(orderRoutes, fnMergeRoute);
// $utils.each(amendRoutes, fnMergeRoute);

$utils.each(tradeRoutes, fnMergeRoute);
// $utils.each(tourRoutes, fnMergeRoute);
// $utils.each(tripRoutes, fnMergeRoute);
$utils.each(flightCNRoutes, fnMergeRoute);
$utils.each(flightRoutes, fnMergeRoute);
$utils.each(mallflightCNRoutes, fnMergeRoute);
$utils.each(mallflightGJRoutes, fnMergeRoute);
$utils.each(mallhotelCNRoutes, fnMergeRoute);
$utils.each(mallhotelGJRoutes, fnMergeRoute);
$utils.each(mallTrainRoutes, fnMergeRoute);

// $utils.each(TrainOrderRoutes, fnMergeRoute);
// $utils.each(TrainTicketReferRoutes, fnMergeRoute);
$utils.each(baseRoutes, fnMergeRoute);
$utils.each(mallRoutes, fnMergeRoute);
$utils.each(billRoutes, fnMergeRoute);
$utils.each(adapterRouter, fnMergeRoute);

$utils.each(newdemandRoutes, fnMergeRoute);
$utils.each(demandRoutes, fnMergeRoute);
$utils.each(manageRouter, fnMergeRoute);
$utils.each(invoiceRouter, fnMergeRoute);
$utils.each(expressRouter, fnMergeRoute);
$utils.each(insuranceRouter, fnMergeRoute);
$utils.each(adminRouter, fnMergeRoute);
$utils.each(statisticsRouter, fnMergeRoute);
$utils.each(policyRouter, fnMergeRoute);
$utils.each(btripRouter, fnMergeRoute);
$utils.each(btripplatformRoutes, fnMergeRoute);
$utils.each(meetingRoutes, fnMergeRoute);

// $utils.each(recepayRoutes, fnMergeRoute);
routes.push({
  path: "/",
  component: index,
});
routes.push({
  path: "*",
  component: p404,
});
export default new Router({
  mode: "history",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js